import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Thrown when there is a network error
 */
export class NetworkError extends CedeSDKError {
  constructor(code = SdkErrorCodes.NETWORK_ERROR, message = SdkErrorMessages.NETWORK_ERROR) {
    super(code, message);
    this.name = "NetworkError";
  }
}

/**
 * @description Thrown when the network is not found
 */
export class NetworkNotFoundError extends NetworkError {
  constructor(network: string) {
    super(SdkErrorCodes.NETWORK_NOT_FOUND, SdkErrorMessages.NETWORK_NOT_FOUND(network));
    this.name = "NetworkNotFoundError";
  }
}

/**
 * @description Thrown when the network is not found for the token symbol
 */
export class NetworkNotFoundForTokenSymbol extends NetworkError {
  constructor(symbol: string) {
    super(
      SdkErrorCodes.NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL,
      SdkErrorMessages.NETWORK_NOT_FOUND_FOR_TOKEN_SYMBOL(symbol),
    );
    this.name = "NetworkNotFoundForTokenSymbol";
  }
}
